import { render, staticRenderFns } from "./MissingUnitsModalItem.vue?vue&type=template&id=60dd35a9&scoped=true&"
import script from "./MissingUnitsModalItem.vue?vue&type=script&lang=js&"
export * from "./MissingUnitsModalItem.vue?vue&type=script&lang=js&"
import style0 from "./MissingUnitsModalItem.vue?vue&type=style&index=0&id=60dd35a9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd35a9",
  null
  
)

export default component.exports